import React, { useEffect, useState } from 'react';
import "./styles.css"
import TwoFactorAuthentication from './TwoFactorAuth';
import { useParams } from 'react-router-dom';
import Whistle from './Whistle';
import { Container } from 'reactstrap';
import { APIGet, APIPost, APIDelete } from '../../API';
import { Loading } from '../../c/Loading';
import { AlertModal } from '../../c/Modals';
import SibilusNavbar from '../../c/Navbar';
import { RenderIf } from '../../helpers/RenderIf';
import { extractMessages } from '../../helpers/cleanLogs';


const WhistlePage = () => {
	const { access_id } = useParams();
	const [audioContentUrl, setAudioContentUrl] = useState(undefined)
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [confirmationModal, setConfirmationModal] = useState(false)
	const [showLoading, setShowLoading] = useState(false)
	const [whistle, setWhistle] = useState(undefined);
	const [authRequired, setAuthRequired] = useState(false);
	const [userAuth, setUserAuth] = useState({ two_fa_methods: [], picked_two_method: undefined })
	const [codeStatus, setCodeStatus] = useState(undefined);
	const [messages, setMessages] = useState([])
	const [files, setFiles] = useState([])

	const getWhistle = (authentication = undefined) => {
		setShowLoading(true)
		let resource = 'whistles/' + access_id;
		if (authentication) {
			const { auth_code } = authentication;
			resource += `?auth_code=${auth_code}`;
		}
		APIGet(resource).then((res) => {
			if (!res.data.whistle) {
				setShowLoading(false)
				setAuthRequired(true);
				setUserAuth(res.data)
			} else {
				setShowLoading(false)
				if (res.data.whistle["audioContent"]) {
					setAudioContentUrl(res.data.whistle.audioContent.url)
				}
				setWhistle(res.data.whistle);
			}
		}).catch((error) => {
			setShowLoading(false)
			console.log('Error:', error);
			if (error.response.status === 401) {
				setCodeStatus("invalid code")
			}
			setAlertType({ type: "error", text: error.response.data })
			setShowAlert(true)
		});
	};


	const sendCode = () => {
		setShowLoading(true)
		setCodeStatus("code sent");
		const resource = 'whistles/' + access_id + '/auth';
		const data = { action: 'create_auth' };
		APIPost(resource, data).then(() => {
			setShowLoading(false)
		}).catch((err) => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		});
	};

	const confirmAuthCode = (authentication) => {
		getWhistle(authentication);
	};

	const handleDeleteWhistle = () => {
		setConfirmationModal(!confirmationModal)
		if (confirmationModal) {
			const whistleId = whistle.id
			setShowLoading(true)
			APIDelete("whistles/" + whistleId, { action: "delete_whistle", access_id: access_id }).then((res) => {
				setShowLoading(false)
				setAlertType({ text: "Entry deleted", type: "success" })
				setShowAlert(true)
			}).catch(err => {
				setShowLoading(false)
				setAlertType({ type: "error", text: err.response.data })
				setShowAlert(true)
			})
		}
	}

	const deleteMessage = (messageId) => {
		const whistleId = whistle.id
		const accessId = whistle["whistle_access_id"] || null
		setShowLoading(true)
		const resource = `whistles/${whistleId}/log/${messageId}`
		APIDelete(resource, { action: "delete_log", access_id: accessId }).then(res => {
			setShowLoading(false)
			setMessages(prevS => prevS.filter(m => m.id !== messageId))
		}).catch(err => {
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		})
	}

	useEffect(() => {
		access_id && !whistle && getWhistle();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (whistle)
			setMessages(extractMessages(whistle.messages))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [whistle])

	if (!whistle && !authRequired) {
		return (<>
			<Loading
				showLoading={showLoading}
				inFront
			/>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>)
	}

	if (!whistle && authRequired) {
		return (<>
			<RenderIf condition={!showLoading}>
				<SibilusNavbar anonymous />
				<div className="twofa-whistlepage">
					<TwoFactorAuthentication
						userAuth={userAuth}
						codeStatus={codeStatus}
						sendCode={sendCode}
						confirmAuthCode={confirmAuthCode}
					/>
				</div>
			</RenderIf>
			<Loading
				showLoading={showLoading}
				inFront
			/>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>)
	}

	return (
		<>
			<Container fluid className="px-0">
				<RenderIf condition={whistle}>
					<RenderIf condition={whistle.mode === "nonanonymous"}>
						<SibilusNavbar nonanonymous />
					</RenderIf>
					<RenderIf condition={whistle.mode === "anonymous"}>
						<SibilusNavbar anonymous />
					</RenderIf>
					<Whistle
						whistle={whistle}
						deleteMessage={deleteMessage}
						messages={messages}
						setMessages={setMessages}
						audioContentUrl={audioContentUrl}
						handleDeleteWhistle={handleDeleteWhistle}
						setConfirmationModal={confirmationModal}
						confirmationModal={confirmationModal}
						files={files}
						setFiles={setFiles}
						getWhistle={getWhistle}
					/>
				</RenderIf>
			</Container >
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
			<Loading
				showLoading={showLoading}
				inFront
				overlay
			/>
		</>
	);
};

export default WhistlePage;
